/// <reference path="koyori.ts" />
/// <reference path="fetch.ts" />

/**
 * エレメントを別ファイルから取得して設定します。
 * <dl>
 * <dt>属性</dt>
 * </dl>
 */
class KoyoriInclude extends KoyoriElement {

	static get observedAttributes() {
		return ['src'];
	}

	srcChanged(value: String): void {
		KoyoriFetch.fetch(this.getAttribute('src'), null, {
			success: response => {
				response.text().then(text => {
					this.innerHTML = text;
					this.querySelectorAll('script').forEach(oldScript => {
						let newScript = document.createElement('script');
						newScript.textContent = oldScript.textContent;
						oldScript.replaceWith(newScript);
					});
					KoyoriElement.fireEvent(this, 'load');
				});
				return true;
			}
		}, this);
	}
}
window.customElements.define('koy-include', KoyoriInclude);